<template>
  <div class="page-scenarios">
    <header
      class="banner"
      :style="{
        backgroundImage: `url(${transformImage(
          get(scenario, 'background_cover_url')
        )})`,
      }"
    >
      <div class="content flex flex-col items-center justify-center">
        <h1>{{ scenario?.title }}</h1>
        <p>
          {{ scenario?.summarize }}
        </p>
      </div>
    </header>

    <article class="page-container">
      <section
        v-if="get(scenario, 'config', []).length > 1"
        class="module-tabs"
      >
        <Tabs
          v-model:active="activeTab"
          :tabList="get(scenario, 'config', [])"
        />
      </section>
      <section
        v-for="(item, idx) in currentScenario?.list"
        :key="idx + item.type + item.title + item.desc + item.id"
        class="module-item mb-[80px]"
      >
        <template v-if="item.type === 'VideoCard'">
          <VideoCard :data="item" :revert="idx % 2 === 0" />
        </template>
        <template v-if="item.type === 'EnterpriseCard'">
          <EnterpriseCard :data="item" />
        </template>
        <template v-if="item.type === 'TemplateCard'">
          <ClientOnly>
            <TemplateCard
              :data="item as unknown as ScenariosTemplateConfig"
              :filteredTemplates="filteredTemplates"
            />
          </ClientOnly>
        </template>
      </section>
    </article>

    <footer v-if="isChinese()" class="mt-[40px] relative">
      <Resource
        :src="getFeUrl('/youyan-platform/png/scenarios/footer-3.jpg')"
        class="w-full"
      />
    </footer>
  </div>
</template>
<script lang="ts" setup>
import { get } from 'lodash-es'
import Tabs from './components/tabs.vue'
import VideoCard from './components/video-card/index.vue'
import EnterpriseCard from './components/enterprise-card/index.vue'
import TemplateCard from './components/template-card/index.vue'
import { getScenariosDetail } from '~/api/module/scenarios'
import { PageKey } from '~/constants/page'
import { ClientOnly } from '#components'
import type { ScenariosTemplateConfig } from '~/api/interface'
import { useWatchPageSeoData } from '~/hooks/useSeo'
import { B_SIDE_QRCODE, C_SIDE_QRCODE } from '~/constants'

provideResourceLocation({
  source: SOURCE.SCENARIOS,
})

const route = useRoute()
const router = useRouter()

const { data: scenario } = useAsyncData(async () => {
  const res = await getScenariosDetail({
    tag_outer_id: String(route.params.id),
    // tag_outer_id: 'this_is_test_outer_id',
  })

  const scenario = get(res, 'data[0]')

  if (!scenario) {
    router.replace({ name: PageKey.NOT_FOUND })
  }
  return scenario
})

const activeTab = ref(0)

const currentScenario = computed(() => {
  return get(scenario.value, `config[${activeTab.value}]`)
})

const filteredTemplates = computed(() => {
  return (
    currentScenario.value?.list
      .filter((item) => item.type === 'VideoCard')
      .map((v) => v.template.id) || []
  )
})

const seoData = computed(() => {
  return {
    seo_title: scenario.value?.title,
    seo_description: scenario.value?.summarize,
  }
})

useWatchPageSeoData(seoData)
</script>
<style lang="scss" scoped>
.page-scenarios {
  section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &.module-tabs {
      margin-bottom: 40px;
    }
  }
  .banner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 266px;
    background-size: cover;
    .content {
      position: relative;
      color: var(--purple-10);
      width: 1200px;
      margin: 0 auto;
      text-align: center;

      display: flex;
      .left {
        width: 640px;
      }
      .right {
        flex: 1;
      }
      h1 {
        font-size: 38px;
        font-weight: 600;
        line-height: 53px;
        margin-bottom: 16px;
        margin-top: 0;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;
        margin: 0;
      }
      .create-btn {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
  .page-container {
    width: 1200px;
    margin: 0 auto;
    padding-top: 80px;
  }
}
</style>
